import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast'; // 👈 1. Toaster Import kiya gaya hai
import { CartProvider } from './context/CartContext';
import { WishlistProvider } from './context/WishlistContext'; 
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute'; 
import Home from './pages/customer/Home';
import Shop from './pages/customer/Shop';
import ProductDetails from './pages/customer/ProductDetails';
import Cart from './pages/customer/Cart';
import Checkout from './pages/customer/Checkout';
import MyOrders from './pages/customer/MyOrders';
import OrderTracking from './pages/customer/OrderTracking';
import CustomerProfile from './pages/customer/CustomerProfile'; 
import AdminDashboard from './pages/admin/AdminDashboard';
import Login from './pages/Login';

function App() {
  return (
    <WishlistProvider> 
      <CartProvider>
        <Router>
          {/* 👈 2. Professional Toast Notifications ke liye Toaster yahan add kiya gaya hai */}
          <Toaster 
            position="bottom-right" 
            reverseOrder={false} 
            toastOptions={{
              duration: 3000,
              style: {
                background: '#18181b',
                color: '#fff',
                fontSize: '13px',
                fontWeight: '600',
                borderRadius: '12px',
                padding: '12px 16px',
              },
            }}
          />

          <div className="flex flex-col min-h-screen">
            {/* Navigation Bar */}
            <Navbar />

            {/* Main Content Pages */}
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/product/:id" element={<ProductDetails />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/my-orders" element={<MyOrders />} />
                <Route path="/track-order" element={<OrderTracking />} />
                
                {/* Protected Customer Profile Route */}
                <Route 
                  path="/profile" 
                  element={
                    <ProtectedRoute>
                      <CustomerProfile />
                    </ProtectedRoute>
                  } 
                />
                
                {/* Protected Admin Route */}
                <Route 
                  path="/admin" 
                  element={
                    <ProtectedRoute adminOnly={true}>
                      <AdminDashboard />
                    </ProtectedRoute>
                  } 
                />
                
                <Route path="/login" element={<Login />} />
              </Routes>
            </main>

            {/* Footer */}
            <Footer />
          </div>
        </Router>
      </CartProvider>
    </WishlistProvider>
  );
}

export default App;